/**
 * Cuando GROUP BY o listas de campos se partían por comas de forma ingenua,
 * CONCAT(a, b, c) quedaba en tres entradas. Si además existe la expresión CONCAT
 * completa, eliminamos esos fragmentos para no generar SQL inválido
 * (p. ej. CONCAT(x AS "CONCAT(x"...).
 */

function isCompleteConcatExpression(s: string): boolean {
  const t = s.trim()
  if (!/^CONCAT\s*\(/i.test(t)) return false
  let depth = 0
  for (let i = 0; i < t.length; i++) {
    const ch = t[i]
    if (ch === '(') depth++
    else if (ch === ')') {
      depth--
      if (depth === 0 && i === t.length - 1) return true
    }
  }
  return false
}

function isConcatCommaFragment(fullExists: boolean, f: string): boolean {
  if (!fullExists) return false
  const t = f.trim()
  if (t === "' - '" || t === "'' - ''" || t === '" - "') return true
  if (/^CONCAT\s*\(/i.test(t) && !isCompleteConcatExpression(t)) return true
  // Último trozo típico: "tabla.campo)" sin CONCAT(
  if (/^[\w.]+\)\s*$/i.test(t) && !t.includes('(')) return true
  return false
}

export function removeConcatCommaArtifacts(fields: string[] | undefined): string[] {
  if (!fields?.length) return fields ?? []
  const trimmed = fields.map((f) => f.trim()).filter(Boolean)
  const fullExists = trimmed.some(isCompleteConcatExpression)
  if (!fullExists) return [...fields]

  const out = trimmed.filter((f) => !isConcatCommaFragment(true, f))
  return out.length === trimmed.length ? [...fields] : out
}

/**
 * Elimina del SELECT la cláusula CONCAT mal generada cuando los fragmentos
 * se convirtieron en `campo AS "alias"` dentro de CONCAT (syntax error near AS).
 * Solo afecta al patrón conocido del bug del query builder.
 */
export function repairSqlSelectListConcatArtifact(sql: string): string {
  if (typeof sql !== 'string') return ''
  if (!sql.includes('CONCAT(municipios.nombre AS "CONCAT')) return sql
  const re =
    /,\s*CONCAT\s*\(\s*municipios\.nombre\s+AS\s+"CONCAT\(municipios\.nombre"[\s\S]*?valoraciones_economicas\.formacion_arbolada\)\s+AS\s*"[^"]*"\s*/gi
  return sql.replace(re, '')
}
